import { render, staticRenderFns } from "./AnsweredForms.vue?vue&type=template&id=f529fdf6&scoped=true&"
import script from "./AnsweredForms.vue?vue&type=script&lang=js&"
export * from "./AnsweredForms.vue?vue&type=script&lang=js&"
import style0 from "./AnsweredForms.vue?vue&type=style&index=0&id=f529fdf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f529fdf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
